"use client";
import type React from "react"
import { TopBar } from "@/components/top-bar"
import { usePathname } from "next/navigation";
import { AppSidebar } from "@/components/app-sidebar";
import { CopilotBar } from "@/components/copilot/CopilotBar"
import { HiringStage } from "@/components/careers/HiringStage"
import { useEffect } from "react"
import { useDocumentLanguage } from "@/lib/i18n/useDocumentLanguage"
import { usePortalLanguage } from "@/lib/i18n/usePortalLanguage"
import "@fontsource-variable/inter"
import "@/components/careers/apply-page.css"
import "@/styles/recruiter.css"
import "@/styles/recruiter-home.css"
import "@/styles/recruiter-roles-company.css"
import "@/styles/recruiter-screening-interviews.css"
import "@/styles/recruiter-reports.css"
import "@/styles/recruiter-talent.css"

export default function DashboardLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const pathname = usePathname();
  const hideMainSidebar = /^\/dashboard\/agency\/reports\/[^/]+$/.test(pathname || "");
  const hideTopBar = hideMainSidebar;
  usePortalLanguage(true);
  useDocumentLanguage();

  // The recruiter look is scoped to `.rx` (styles/recruiter.css). It goes on
  // <html> because dialogs and menus render outside this layout.
  useEffect(() => {
    document.documentElement.classList.add("rx")
    return () => document.documentElement.classList.remove("rx")
  }, [])

  return (
    <div className="rx-root flex min-h-screen bg-background">
      <HiringStage />
      {/* min-w-0: without it this flex item grows to its widest child (the Nova
          hint, a table), and the whole page scrolls sideways on a phone. */}
      <div className="flex-1 min-w-0">


        <div className="flex h-screen">
          {!hideMainSidebar && <AppSidebar />}
          <div className="flex-1 flex flex-col overflow-hidden">
            {!hideTopBar && <TopBar />}
            <main className="flex-1 overflow-auto bg-background">
              <CopilotBar />
              {children}
            </main>
          </div>
        </div>
      </div>
    </div>
  )
}
